import { UPDATEPLAYING } from "../constants/action_types.js";

const playing_handler = (playing = false, action) =>
{
  switch (action.type)
  {
    case UPDATEPLAYING:
      return action.payload;
    default:
      return playing;
  }
}

export default playing_handler;